module.exports = __webpack_public_path__ + "img/STB-Logo.1980053a.png";